// import logo from "../img/logo.png";
import { GiHamburgerMenu } from "react-icons/gi";
import "./header.scss";
import React from "react";
import { Link } from "react-scroll";
import { useState } from "react";

function Header() {
  const [Toggle, toggleBtn] = useState(false);
  return (
    <>
      <div className="header">
        <div className="navbar">
          <div className="header-left">
            <div id="logo">
              <a href="/">
                <strong>S</strong>
                <span>oham </span>
                <strong>M</strong>
                <span>andaliya</span>
                {/* <img src={logo} alt="No image available"></img> */}
              </a>
            </div>
            {/* <button id="navbtn" onClick={() => toggleBtn(!Toggle)}>C</button> */}
          </div>
          <div
            className={
              Toggle ? "header-right header-responsive" : "header-right"
            }
          >
            {/* </div>
          <div className="header-right"> */}
            <ul>
              <li>
                {/* <a href="#home">Home</a> */}
                <Link to="home" smooth={true}>
                  Home
                </Link>
              </li>
              <li>
                {/* <a href="#about">About</a> */}
                <Link to="about" smooth={true}>
                  About
                </Link>
              </li>
              <li>
                {/* <a href="#projects">Projects</a> */}
                <Link to="projects" smooth={true}>
                  Projects
                </Link>
              </li>
              <li>
                {/* <a href="#skills">Skills</a> */}
                <Link to="skills" smooth={true}>
                  Skills
                </Link>
              </li>
              <li>
                {/* <a href="#contact">Contact</a> */}
                <Link to="contact" smooth={true}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div className="hamburger-menu">
            <span onClick={() => toggleBtn(!Toggle)}>
              <GiHamburgerMenu />
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
